"use client";

import { createContext, useContext } from "react";
import { dictionaries, type Locale, type Dictionary } from "./shared";

const LocaleContext = createContext<Locale | null>(null);

// Seeded once from the server (root layout reads the cookie), then handed
// down via context so every Client Component in the tree sees the same
// locale without each one re-reading cookies itself. Switching locale sets
// the cookie and calls router.refresh() — that re-runs the root layout,
// which re-renders this Provider with the new value, which every useT()
// consumer picks up automatically.
export function LocaleProvider({
  locale,
  children,
}: {
  locale: Locale;
  children: React.ReactNode;
}) {
  return <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>;
}

export function useLocale(): Locale {
  const locale = useContext(LocaleContext);
  if (!locale) throw new Error("useLocale must be used within a LocaleProvider");
  return locale;
}

export function useT(): Dictionary {
  return dictionaries[useLocale()];
}
